
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiktok",
      function () {
        return require("private-next-pages/tiktok.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiktok"])
      });
    }
  